module.exports = __webpack_public_path__ + "img/dummy-avatar.2fe3cbc3.jpg";